import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  UploadScorePayload,
  UploadScoreResponseData,
  UploadScoreState,
} from 'features/Yucollect/UploadScore/uploadScore.type';

export const uploadScoreInitialState: UploadScoreState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

const uploadScoreSlice = createSlice({
  name: 'uploadScore',
  initialState: uploadScoreInitialState,
  reducers: {
    uploadScoreReq(state, _action: PayloadAction<UploadScorePayload>) {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.data = null;
    },
    uploadScoreSuccess(state, action: PayloadAction<UploadScoreResponseData>) {
      state.loading = false;
      state.success = true;
      state.error = null;
      state.data = action.payload;
    },
    uploadScoreFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    resetUploadScore: () => uploadScoreInitialState,
  },
});

export const {
  uploadScoreReq,
  uploadScoreSuccess,
  uploadScoreFailure,
  resetUploadScore,
} = uploadScoreSlice.actions;

export type { UploadScoreState };

export default uploadScoreSlice.reducer;
